<template>
  <div class="tab-content-item">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.tab-content-item {
  display: none;

  &.active {
    display: block;
  }
}
</style>
